import ImagePackElement from "./imagePack.element";
import {useApp} from "../app.context";
import Checkmark from "./checkmark";
import {useNavTarget} from "./useNavTarget";
import {NavTarget} from "../utils/navTarget";

interface EntityLabelProps {
    id: string;
    onDelete?(): void;
    // Appended to the localized name. Used by the Tech Tree tab to show which
    // tech node has unlocked this entity, e.g. " (Exploration)".
    suffix?: string;
    // Image-pack level to render — Buildings need startLevel because their
    // pack reserves index 0 as a dead slot. Units / Resources / Tiles use
    // level 0 (the default).
    level?: number;
    // Ctrl/Cmd-click navigation target (the kind can't be inferred from id
    // alone, so the call site supplies it). Omitted → not navigable.
    navTarget?: NavTarget;
}

function EntityLabel(props: EntityLabelProps) {
    const {getLocalizationValue, confirmDelete} = useApp();

    return (
        <div className={'layout horizontal stretch gap label'} {...useNavTarget(props.navTarget)} style={{alignItems: 'center', padding: 5}}>
            <div className={'layout horizontal gap'} style={{alignItems: 'center'}}>
                <div style={{position: 'relative'}}>
                    <ImagePackElement id={props.id} level={props.level ?? 0} size={50}/>
                    <Checkmark id={props.id} style={{position: 'absolute', top: 2, right: 2}}/>
                </div>
                <p style={{width: 160, padding: 5}}>{getLocalizationValue(props.id)}</p>
            </div>
            {props.suffix && <p style={{marginLeft: 'auto', padding: 5}}>{props.suffix.trim()}</p>}
            {props.onDelete && <button style={{marginRight: 8}}>
                <span className={'fa-solid fa-trash'} style={{color: 'white'}} onClick={async (e) => {
                    e.stopPropagation();
                    if (props.onDelete && await confirmDelete(getLocalizationValue(props.id))) {
                        props.onDelete();
                    }
                }}/>
            </button>}
        </div>
    )
}

export default EntityLabel;